import type { ReactNode } from 'react';
import type { ReportFiltersField } from '../../reportFilters.types';
import { DateRangeFilterField } from './DateRangeFilterField';
import { MultiSelectFilterField } from './MultiSelectFilterField';
import { TextFilterField } from './TextFilterField';
import { ToggleGroupFilterField } from './ToggleGroupFilterField';

interface RenderReportFilterFieldProps {
  field: ReportFiltersField;
}

export const renderReportFilterField = ({
  field,
}: RenderReportFilterFieldProps): ReactNode => {
  switch (field.type) {
    case 'multi-select':
      return <MultiSelectFilterField key={field.id} field={field} />;
    case 'text':
      return <TextFilterField key={field.id} field={field} />;
    case 'toggle-group':
      return <ToggleGroupFilterField key={field.id} field={field} />;
    case 'date-range':
      return (
        <DateRangeFilterField
          key={`${field.idFrom}-${field.idTo}`}
          field={field}
        />
      );
    default:
      return null;
  }
};
